import { useCallback } from 'react';
import { useProductCategoriesLazyQuery } from '../types';
import { removeNullishItems } from '@kidslabs/module-core';

export const useGetRelatedProductsCategory = () => {
    const [getProductCategories, { loading }] = useProductCategoriesLazyQuery();

    // The product's closest category is the last item in array
    const getClosestCategory = useCallback(
        async (sku: string) => {
            const data = await getProductCategories({
                variables: { sku },
                fetchPolicy: 'no-cache',
            });
            const productBySkuResult = data?.data?.productBySku;

            // Only ConfigurableProduct or SimpleProduct have categories
            if (
                productBySkuResult?.__typename === 'ConfigurableProduct' ||
                productBySkuResult?.__typename === 'SimpleProduct'
            ) {
                return removeNullishItems(productBySkuResult?.categories ?? [])?.at(-1);
            }
            return undefined;
        },
        [getProductCategories]
    );

    return {
        getClosestCategory,
        loading,
    };
};
